export default {
  /**
   * Set the decision value.
   *
   * @param {Object} state
   * @param {Boolean} decision
   */
  SET_DECISION(state, { decision }) {
    state.decision = decision
  },
}
